module.exports = __webpack_public_path__ + "img/jose_dosantos_assume_power.696ee416.png";